@if (seatDetails) {
  {{humanReadableSeatDetails(seatDetails, translate, displayedSeatingInformation)}}
}